import React, { useState } from "react";
import { motion } from "framer-motion";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "phone") {
      const cleaned = value.replace(/\D/g, ""); 
      if (cleaned.length > 10) return; 
      setFormData((prev) => ({ ...prev, [name]: cleaned }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, phone, message } = formData;
  
    if (!name || !email || !phone || !message) {
      alert("Please fill in all fields!");
      return;
    }
  
    // Custom phone validation: exactly 10 digits
    const cleanedPhone = phone.replace(/\D/g, "");
    if (cleanedPhone.length !== 10) {
      toast.warn("Phone number must be exactly 10 digits.");
      return;
    }
  
    // Custom email validation using regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.warn("Please enter a valid email address.");
      return;
    }
  
    setLoading(true);
  
    try {
      const response = await fetch("https://100billionrealestate.com/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
  
      if (response.ok) {
        setSubmitted(true);
        setFormData({ name: "", email: "", phone: "", message: "" });
        toast.success("Message sent successfully!");
      } else {
        toast.error("Something went wrong.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };
  
  
  return (
    <div>
      {/* Heading Section */}
      <div className="other-pages-main-section-v9">
        <motion.h2
          className="enquiry-heading"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Contact Us
        </motion.h2>
        <motion.p
          className="enquiry-subheading"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          We’d love to hear from you! Reach out through the form or details below.
        </motion.p>
      </div>

      {/* Contact Info Cards */}
      <div className="contact-info-cards-v9">
        <div className="contact-card-v9">
          <h4>Email</h4>
          <p>info@v9primeforce.com</p>
        </div>
        <div className="contact-card-v9">
          <h4>Phone</h4>
          <p>9967680119 / 7208328645</p>
        </div>
        <div className="contact-card-v9">
          <h4>Address</h4>
          <p>Joshi Associate / 002 AANGHI CHS Near union bank Mira Bhayandar Road Mira Road east Dist thane 401107</p>
        </div>
      </div>

      {/* Contact Form */}
      <motion.div
        className="enquiry-wrapper"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.form
          onSubmit={handleSubmit}
          className="enquiry-form"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Enter your full name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={handleChange}
              title="Please enter a valid phone number"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Your Message</label>
            <textarea
              id="message"
              name="message"
              placeholder="Enter your enquiry"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>

          <motion.button
            type="submit"
            className="submit-btn"
            disabled={loading}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ duration: 0.2 }}
          >
            {loading
              ? "Submitting..."
              : submitted
              ? "Thank you for your enquiry!"
              : "Submit Enquiry"}
          </motion.button>
        </motion.form>
      </motion.div>

      {/* Map */}
      <div className="contact-map-v9" style={{ marginTop: "40px", height: "400px" }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3766.1377548543705!2d72.87196847374243!3d19.276374745654365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b06790000003%3A0xc36868dfc1ceba56!2sJoshi%20Associates%20(Income%20Tax)!5e0!3m2!1sen!2sin!4v1744900337157!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
};

export default Contact;
